import React, { useState, useEffect, useContext } from "react"
import { useStaticQuery, graphql } from "gatsby"

import Layout from "../../layout"
import SEO from "../../seo"

import { Cover } from "../../anti/cover/cover"
import { Card } from "../../anti/card/card"
import { Container, Section } from "../../anti/grid/grid"
import { Breadcrumb } from "../../anti/breadcrumb/breadcrumb"

import Shape from "../../../assets/img/common/shape.png"

import { LangContext } from "../../../context/LangContext"

import "@glidejs/glide/dist/css/glide.core.min.css"
import "@glidejs/glide/dist/css/glide.theme.min.css"
import { useMediaPredicate } from "react-media-hook"

const IndustrialPage = ({ location, pageContext }) => {
  const { lang, setLang } = useContext(LangContext)
  const resizeScreen = useMediaPredicate("(min-width:768px)")

  const [keyword, setKeyword] = useState()
  const [loading, setLoading] = useState(false)
  const [type, setType] = useState("")
  const [notfound, setNotFound] = useState([])

  const offset = 0
  const defaultPage = 18
  const limit = 6
  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(defaultPage)

  const data = useStaticQuery(graphql`
    query {
      imgCover: file(relativePath: { eq: "sample/bg_rectangle-dark-2.jpg" }) {
        id
        name
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      wordPress {
        #Query Cover
        pageBy(uri: "development-landing") {
          title
          slug
          blocks {
            name
            # ACF Development Landing
            ... on WordPress_AcfDevelopmentLandingBlock {
              name
              attributes {
                className
              }
              developmentLanding {
                name
                landing {
                  title
                  text
                }
                cover {
                  img {
                    sourceUrl
                  }
                  imgMobile {
                    sourceUrl
                  }
                  label
                  title
                }
              }
            }
          }
          translation(language: ID) {
            title
            slug
            blocks {
              name
              ... on WordPress_AcfDevelopmentLandingBlock {
                name
                attributes {
                  className
                }
                developmentLanding {
                  name
                  landing {
                    title
                    text
                  }
                  cover {
                    img {
                      sourceUrl
                    }
                    imgMobile {
                      sourceUrl
                    }
                    label
                    title
                  }
                }
              }
            }
          }
        }
        propertyTypes(where: { slug: "industrial" }) {
          nodes {
            name
            slug
            projects(first: 500) {
              nodes {
                title
                slug
                menuOrder
                projectTags {
                  nodes {
                    name
                  }
                }
                propertyTypes {
                  nodes {
                    translation(language: ID) {
                      seo {
                        title
                        metaDesc
                        twitterTitle
                        twitterDescription
                        twitterImage {
                          sourceUrl
                        }
                        opengraphTitle
                        opengraphDescription
                        opengraphImage {
                          sourceUrl
                        }
                      }
                    }
                    seo {
                      title
                      metaDesc
                      twitterTitle
                      twitterDescription
                      twitterImage {
                        sourceUrl
                      }
                      opengraphTitle
                      opengraphDescription
                      opengraphImage {
                        sourceUrl
                      }
                    }
                    slug
                  }
                }
                blocks {
                  name
                  ... on WordPress_AcfCoverMainBlock {
                    attributes {
                      className
                    }
                    coverMain {
                      img {
                        mediaItemUrl
                      }
                      imgOverlay
                      label
                      title
                      text
                      buttons {
                        text
                        link {
                          target
                          url
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  //Query List Project
  const projectsByTypes = data.wordPress.propertyTypes.nodes[0].projects.nodes
  let allProjects = []
  let projectsFeatured = []

  projectsByTypes.map(item => {
    if (item.menuOrder && item.projectTags.nodes.length === 0) {
      allProjects[item.menuOrder - 1] = {
        ...item,
        type: "Industrial",
      }
    } else if (!item.menuOrder && item.projectTags.nodes.length === 0) {
      allProjects.push({ ...item, type: "Industrial" })
    }

    if (item.projectTags.nodes.length > 0) {
      projectsFeatured.push({ ...item, type: "Industrial" })
    }
  })

  const [allProjectsIndustrial, setAllProjectsIndustrial] = useState(
    allProjects && projectsFeatured && allProjects.concat(projectsFeatured)
  )

  //Query Content
  const dev = data.wordPress.pageBy.blocks.find(
    x => x.developmentLanding.name === "Industrial"
  )

  const devID =
    data.wordPress.pageBy.translation !== null
      ? data.wordPress.pageBy.translation.blocks.find(
          x => x.developmentLanding.name === "Industrial"
        )
      : data.wordPress.pageBy.blocks.find(
          x => x.developmentLanding.name === "Industrial"
        )

  const devCover =
    lang == "EN"
      ? dev?.developmentLanding?.cover
      : devID?.developmentLanding?.cover
  const devLanding =
    lang == "EN"
      ? dev?.developmentLanding?.landing
      : devID?.developmentLanding?.landing

  const BlankState = <div className="text-center">No result found!</div>

  const searchByKeywordV2 = () => {
    let match = []
    let pagingLoadMore = []

    allProjectsIndustrial
      .filter(x => x != null)
      .map((item, i) => {
        if (item.title.toLowerCase().search(keyword.toLowerCase()) !== -1) {
          const cover = item.blocks.find(x => x.name === "acf/cover-main")
          match.push(
            <div className="col-sm-6 col-md-4" key={`${item.title}-${i}`}>
              <Card
                variant="overlay"
                title={item.title}
                text={item.type}
                img={
                  (cover &&
                    cover.coverMain.img &&
                    cover.coverMain.img.mediaItemUrl) ||
                  data.imgCover.childImageSharp.fluid
                }
                imgHeight="h-ratio-3-2"
                className="card-property"
                link={
                  item.propertyTypes.nodes[0] !== undefined &&
                  `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
                }
              />
            </div>
          )
        }
      })

    allProjectsIndustrial.filter(
      x =>
        x != null && x.title.toLowerCase().search(keyword.toLowerCase()) !== -1
    ).length > perPage
      ? pagingLoadMore.push(
          <div className="col-md-12 pb-5 pt-5 text-center paging-sbk-all">
            <button
              className="btn btn-primary w-100 w-md-25 btn-loadmore"
              onClick={handleLoadMore}
            >
              {lang === "EN" ? "Load More" : "Muat lebih banyak"}
            </button>
          </div>
        )
      : ""

    if (match.length > 0 || pagingLoadMore.length > 0) {
      return (
        <>
          {match.slice(offset, perPage)}
          {pagingLoadMore}
        </>
      )
    } else {
      return (
        <>
          <div className="col-12">
            <div className="blank-state text-center mb-5">
              <div>
                <h5 className="text-black">
                  {lang == "EN" ? "Not found" : "Tidak ditemukan"}
                </h5>
                <p>
                  {lang == "EN"
                    ? "Try searching with another keyword."
                    : "Coba cari dengan kata kunci lain."}
                </p>
                <img src={Shape} className="img-fluid" />
              </div>
              <h2 className="text-center">
                {lang == "EN" ? "You May Like:" : "Kamu mungkin suka:"}
              </h2>
            </div>
          </div>
          {allProjects.length > 0 &&
            allProjects.map((item, i) => {
              const cover = item.blocks.find(x => x.name === "acf/cover-main")
              if (i < 3) {
                const cover = item.blocks.find(x => x.name === "acf/cover-main")
                return (
                  <div className="col-sm-6 col-md-4" key={`${item.title}-${i}`}>
                    <Card
                      variant="overlay"
                      title={item.title}
                      text={item.type}
                      img={
                        (cover &&
                          cover.coverMain.img &&
                          cover.coverMain.img.mediaItemUrl) ||
                        data.imgCover.childImageSharp.fluid
                      }
                      imgHeight="h-ratio-3-2"
                      className="card-property"
                      link={
                        item.propertyTypes.nodes[0] !== undefined &&
                        `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
                      }
                    />
                  </div>
                )
              }
            })}
        </>
      )
    }
  }

  const searchByFilter = () => {
    let match = []
    let featuredMatch = []

    allProjects.map((item, i) => {
      if (item.type.toLowerCase() === type) {
        const cover = item.blocks.find(x => x.name === "acf/cover-main")
        match.push(
          <div className="col-sm-6 col-md-4" key={`${item.title}-${i}`}>
            <Card
              variant="overlay"
              title={item.title}
              text={item.type}
              img={
                (cover &&
                  cover.coverMain.img &&
                  cover.coverMain.img.mediaItemUrl) ||
                data.imgCover.childImageSharp.fluid
              }
              imgHeight="h-ratio-3-2"
              className="card-property"
              link={
                item.propertyTypes.nodes[0] !== undefined &&
                `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
              }
            />
          </div>
        )
      }

      if (type === "all") {
        const cover = item.blocks.find(x => x.name === "acf/cover-main")
        match.push(
          <div className="col-sm-6 col-md-4" key={`${item.title}-${i}`}>
            <Card
              variant="overlay"
              title={item.title}
              text={item.type}
              img={
                (cover &&
                  cover.coverMain.img &&
                  cover.coverMain.img.mediaItemUrl) ||
                data.imgCover.childImageSharp.fluid
              }
              imgHeight="h-ratio-3-2"
              className="card-property"
              link={
                item.propertyTypes.nodes[0] !== undefined &&
                `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
              }
            />
          </div>
        )
      }
    })

    projectsFeatured.map((item, i) => {
      if (item.type.toLowerCase() === type) {
        const cover = item.blocks.find(x => x.name === "acf/cover-main")
        featuredMatch.push(
          <div className="col-sm-6 col-md-4" key={`${item.title}-${i}`}>
            <Card
              variant="overlay"
              title={item.title}
              text={item.type}
              label={item.projectTags.nodes[0].name}
              img={
                (cover &&
                  cover.coverMain.img &&
                  cover.coverMain.img.mediaItemUrl) ||
                data.imgCover.childImageSharp.fluid
              }
              imgHeight="h-ratio-3-2"
              className="card-property"
              link={
                item.propertyTypes.nodes[0] !== undefined &&
                `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
              }
            />
          </div>
        )
      }

      if (type === "all") {
        const cover = item.blocks.find(x => x.name === "acf/cover-main")
        featuredMatch.push(
          <div className="col-sm-6 col-md-4" key={`${item.title}-${i}`}>
            <Card
              variant="overlay"
              title={item.title}
              text={item.type}
              label={item.projectTags.nodes[0].name}
              img={
                (cover &&
                  cover.coverMain.img &&
                  cover.coverMain.img.mediaItemUrl) ||
                data.imgCover.childImageSharp.fluid
              }
              imgHeight="h-ratio-3-2"
              className="card-property"
              link={
                item.propertyTypes.nodes[0] !== undefined &&
                `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
              }
            />
          </div>
        )
      }
    })

    if (match.length > 0 || featuredMatch.length > 0) {
      return (
        <>
          {featuredMatch}
          {match}
        </>
      )
    } else {
      return (
        <>
          <div className="col-12">
            <div className="blank-state text-center mb-5">
              <div>
                <h5 className="text-black">
                  {lang == "EN" ? "Not found" : "Tidak ditemukan"}
                </h5>
                <p>
                  {lang == "EN"
                    ? "Try searching with another keyword."
                    : "Coba cari dengan kata kunci lain."}
                </p>
                <img src={Shape} className="img-fluid" />
              </div>
              <h2 className="text-center">
                {lang == "EN" ? "You May Like:" : "Kamu mungkin suka:"}
              </h2>
            </div>
          </div>
          {allProjects.length > 0 &&
            allProjects.map((item, i) => {
              if (i < 3) {
                const cover = item.blocks.find(x => x.name === "acf/cover-main")
                return (
                  <div className="col-sm-6 col-md-4" key={`${item.title}-${i}`}>
                    <Card
                      variant="overlay"
                      title={item.title}
                      text={item.type}
                      img={
                        (cover &&
                          cover.coverMain.img &&
                          cover.coverMain.img.mediaItemUrl) ||
                        data.imgCover.childImageSharp.fluid
                      }
                      imgHeight="h-ratio-3-2"
                      className="card-property"
                      link={
                        item.propertyTypes.nodes[0] !== undefined &&
                        `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
                      }
                    />
                  </div>
                )
              }
            })}
        </>
      )
    }
  }

  const filterAll = () => {
    let match = []
    let pagingLoadMore = []

    allProjectsIndustrial
      .filter(x => x != null)
      .map((item, i) => {
        if (item.type.toLowerCase() === type) {
          if (item.title.toLowerCase().search(keyword.toLowerCase()) !== -1) {
            const cover = item.blocks.find(x => x.name === "acf/cover-main")
            match.push(
              <div className="col-sm-6 col-md-4" key={`${item.title}-${i}`}>
                <Card
                  variant="overlay"
                  title={item.title}
                  text={item.type}
                  img={
                    (cover &&
                      cover.coverMain.img &&
                      cover.coverMain.img.mediaItemUrl) ||
                    data.imgCover.childImageSharp.fluid
                  }
                  imgHeight="h-ratio-3-2"
                  className="card-property"
                  link={
                    item.propertyTypes.nodes[0] !== undefined &&
                    `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
                  }
                />
              </div>
            )
          }
        }

        if (type === "all") {
          if (item.title.toLowerCase().search(keyword.toLowerCase()) !== -1) {
            const cover = item.blocks.find(x => x.name === "acf/cover-main")
            match.push(
              <div className="col-sm-6 col-md-4" key={`${item.title}-${i}`}>
                <Card
                  variant="overlay"
                  title={item.title}
                  text={item.type}
                  label={item.projectTags.nodes[0].name}
                  img={
                    (cover &&
                      cover.coverMain.img &&
                      cover.coverMain.img.mediaItemUrl) ||
                    data.imgCover.childImageSharp.fluid
                  }
                  imgHeight="h-ratio-3-2"
                  className="card-property"
                  link={
                    item.propertyTypes.nodes[0] !== undefined &&
                    `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
                  }
                />
              </div>
            )
          }
        }
      })

    if (type !== "all") {
      allProjectsIndustrial.filter(
        x =>
          x != null &&
          x.title.toLowerCase().search(keyword.toLowerCase()) !== -1
      ).length > perPage
        ? pagingLoadMore.push(
            <div className="col-md-12 pb-5 pt-5 text-center paging-sbk-nall">
              <button
                className="btn btn-primary w-100 w-md-25 btn-loadmore"
                onClick={handleLoadMore}
              >
                {lang === "EN" ? "Load More" : "Muat lebih banyak"}
              </button>
            </div>
          )
        : ""
    }

    if (type === "all") {
      allProjectsIndustrial.filter(
        x =>
          x != null &&
          x.title.toLowerCase().search(keyword.toLowerCase()) !== -1
      ).length > perPage
        ? pagingLoadMore.push(
            <div className="col-md-12 pb-5 pt-5 text-center paging-sbk-all">
              <button
                className="btn btn-primary w-100 w-md-25 btn-loadmore"
                onClick={handleLoadMore}
              >
                {lang === "EN" ? "Load More" : "Muat lebih banyak"}
              </button>
            </div>
          )
        : ""
    }

    if (match.length > 0 || pagingLoadMore.length > 0) {
      return (
        <>
          {match.slice(offset, perPage)}
          {pagingLoadMore}
        </>
      )
    } else {
      return (
        <>
          <div className="col-12">
            <div className="blank-state text-center mb-5">
              <div>
                <h5 className="text-black">
                  {lang == "EN" ? "Not found" : "Tidak ditemukan"}
                </h5>
                <p>
                  {lang == "EN"
                    ? "Try searching with another keyword."
                    : "Coba cari dengan kata kunci lain."}
                </p>
                <img src={Shape} className="img-fluid" />
              </div>
              <h2 className="text-center">
                {lang == "EN" ? "You May Like:" : "Kamu mungkin suka:"}
              </h2>
            </div>
          </div>
          {allProjects.length > 0 &&
            allProjects.map((item, i) => {
              if (i < 3) {
                const cover = item.blocks.find(x => x.name === "acf/cover-main")
                return (
                  <div className="col-sm-6 col-md-4" key={`${item.title}-${i}`}>
                    <Card
                      variant="overlay"
                      title={item.title}
                      text={item.type}
                      img={
                        (cover &&
                          cover.coverMain.img &&
                          cover.coverMain.img.mediaItemUrl) ||
                        data.imgCover.childImageSharp.fluid
                      }
                      imgHeight="h-ratio-3-2"
                      className="card-property"
                      link={`/development/industrial/${item.slug}`}
                    />
                  </div>
                )
              }
            })}
        </>
      )
    }
  }
  const seo =
    pageContext.langKey === "en"
      ? data.wordPress.propertyTypes.nodes[0]?.projects.nodes[0].propertyTypes
          .nodes[0].seo
      : data.wordPress.propertyTypes.nodes[0]?.projects.nodes[0].propertyTypes
          .nodes[0].translation?.seo ||
        data.wordPress.propertyTypes.nodes[0]?.projects.nodes[0].propertyTypes
          .nodes[0].seo

  // Handle Load More
  const handleLoadMore = () => {
    const connectionChecker = window.navigator.onLine
    const nextPage = page + 1
    const nextPerPage = page * limit + defaultPage
    console.log({ nextPage, nextPerPage })
    if (connectionChecker) {
      document.getElementsByClassName("btn-loadmore")[0].innerHTML =
        lang === "EN" ? "Load More" : "Muat lebih banyak"
      setPage(nextPage)
      setPerPage(nextPerPage)
    } else {
      document.getElementsByClassName("btn-loadmore")[0].innerHTML =
        lang == "EN" ? "Failed to Load Data" : "Gagal Memuat Data"
    }
  }

  //Handlechange Input Filter
  const getValue = e => {
    setKeyword(e.target.value)
  }

  const [imageSource, setImageSource] = useState("")

  useEffect(() => {
    let imageSource = data.imgCover.childImageSharp.fluid
    if (devCover?.img?.sourceUrl) {
      imageSource = devCover?.img?.sourceUrl
      if (devCover.imgMobile.sourceUrl && !resizeScreen) {
        imageSource = devCover.imgMobile.sourceUrl
      }
    }
    setImageSource(imageSource)
  }, [resizeScreen, devCover, data])
  return (
    <Layout>
      <SEO
        title={seo?.title}
        desc={seo?.metaDesc}
        fbImg={
          seo?.opengraphImage?.sourceUrl ||
          devCover?.img?.sourceUrl ||
          data.imgCover.childImageSharp.fluid
        }
        fbTitle={seo?.opengraphTitle}
        fbDesc={seo?.opengraphDescription}
        url={location.href}
        twitterTitle={seo?.twitterTitle}
        twitterDesc={seo?.twitterDescription}
        twitterImg={
          seo?.twitterImage?.sourceUrl ||
          devCover?.img?.sourceUrl ||
          data.imgCover.childImageSharp.fluid
        }
      />

      {devCover && (
        <Cover
          variant="basic"
          theme="dark"
          img={imageSource}
          breadcrumb={<Breadcrumb path={location.pathname} />}
          imgHeight="h-500px h-md-600px"
          imgOverlay="30"
          label={devCover?.label}
          title={devCover?.title}
          className="cover-full cover-main"
        />
      )}

      {/* RESIDENCE Only */}
      <Section className="bg-light">
        <Container className="mw-lg text-md-center">
          <h2 className="h2">{devLanding?.title}</h2>
          <p>{devLanding?.text}</p>
          <div className="mt-4 mt-md-5">
            <div className="row">
              <div className="col-lg-12">
                <div class="form-group mb-0">
                  <div className="form-control-wrapper form-w-icon">
                    <input
                      type="text"
                      id="search"
                      placeholder={
                        lang == "EN"
                          ? "Enter keyword here"
                          : "Masukkan kata kunci pencarian disini"
                      }
                      className="form-control"
                      onChange={getValue}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </Section>

      <Section className="py-0 bg-light">
        <div className="row row-0">
          {!keyword &&
            projectsFeatured.length > 0 &&
            projectsFeatured.slice(offset, perPage).map((item, i) => {
              const cover = item.blocks.find(x => x.name === "acf/cover-main")
              return (
                <div
                  className="col-sm-6 col-md-4 ke-1"
                  key={`featured-${item.title}-${i}`}
                >
                  <Card
                    variant="overlay"
                    label={"New"}
                    title={item.title}
                    text={item.type}
                    img={
                      (cover &&
                        cover.coverMain.img &&
                        cover.coverMain.img.mediaItemUrl) ||
                      data.imgCover.childImageSharp.fluid
                    }
                    imgHeight="h-ratio-3-2"
                    className="card-property"
                    link={`/development/${item.slug}`}
                  />
                </div>
              )
            })}
          {!keyword && projectsFeatured.length > perPage ? (
            <div className="col-md-12 pb-5 pt-5 text-center paging-e">
              <button
                className="btn btn-primary w-100 w-md-25 btn-loadmore"
                onClick={handleLoadMore}
              >
                {lang === "EN" ? "Load More" : "Muat lebih banyak"}
              </button>
            </div>
          ) : (
            ""
          )}
          {!keyword &&
            allProjects.length > 0 &&
            allProjects.slice(offset, perPage).map((item, i) => {
              const cover = item.blocks.find(x => x.name === "acf/cover-main")
              return (
                <div className="col-sm-6 col-md-4" key={`${item.title}-${i}`}>
                  <Card
                    variant="overlay"
                    title={item.title}
                    text={item.type}
                    img={
                      (cover &&
                        cover.coverMain.img &&
                        cover.coverMain.img.mediaItemUrl) ||
                      data.imgCover.childImageSharp.fluid
                    }
                    imgHeight="h-ratio-3-2"
                    className="card-property"
                    link={
                      item.propertyTypes.nodes[0] !== undefined &&
                      `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
                    }
                  />
                </div>
              )
            })}
          {!keyword && allProjects.length > perPage ? (
            <div className="col-md-12 pb-5 pt-5 text-center paging-f">
              <button
                className="btn btn-primary w-100 w-md-25 btn-loadmore"
                onClick={handleLoadMore}
              >
                {lang === "EN" ? "Load More" : "Muat lebih banyak"}
              </button>
            </div>
          ) : (
            ""
          )}
        </div>
        {keyword && type.length < 1 && (
          <div className="row row-0">{searchByKeywordV2()}</div>
        )}

        {/* {type.length > 0 && !keyword && (
          <div className="row row-0">{searchByFilter()}</div>
        )} */}

        {keyword && type.length > 0 && (
          <div className="row row-0">{filterAll()}</div>
        )}
      </Section>
    </Layout>
  )
}

export default IndustrialPage
